/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
// import store from './../store'
// import { Message } from 'element-ui'
import api from './../api'

import routes from './routers';
import conf from '../config/url.js'
import store from '../store/index';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes
});
let frontendConfig = localStorage.getItem('frontendConfig') ? JSON.parse(localStorage.getItem('frontendConfig')) : ''
const setWebsiteConfig = async () => {
  // 获取配置参数【主题，页面配置】
  if (!frontendConfig) {
    await api.configure.configuration(conf.confUrl).then(res => {
      if (res.data) {
        frontendConfig = res.data.frontendConfig.filter(item => {
          if (item.key === 'homepage') {
            return true;
          }
        })[0];
        localStorage.setItem('domain', JSON.stringify(res.data.domain)?JSON.stringify(res.data.domain):'');
        localStorage.setItem('theme', res.data.theme || '');
        localStorage.setItem('frontendConfig', frontendConfig ? JSON.stringify(frontendConfig) : '');
        localStorage.setItem('hasGetConfig', '1');
        localStorage.setItem('configurationArr', JSON.stringify(res.data.frontendConfig))
        if (res.data.pageLogo) {
          let link = document.querySelector("link[rel*='icon']");
          link.href = res.data.pageLogo;
          localStorage.setItem('pageLogo', res.data.pageLogo);
        }
        if (res.data.pageTitle) {
          document.title = res.data.pageTitle;
          localStorage.setItem('pageTitle', res.data.pageTitle)
        }
      }
    })
  } else {
    if (localStorage.getItem('pageTitle')) {
      document.title = localStorage.getItem('pageTitle');
    }
    if (localStorage.getItem('pageLogo')) {
      let link = document.querySelector("link[rel*='icon']");
      link.href = localStorage.getItem('pageLogo');
    }
  }

}
setWebsiteConfig();

router.beforeEach(async (to, from, next) => {

  const token = localStorage.getItem('token')
  if(token && to.path === '/login'){ //已经登陆仍然访问login时，直接去首页
    setTimeout(()=>{
      const  frontendConfig = store.state.dynamic.frontendConfig.filter(item => {
        if (item.key === 'homepage') {
          return true;
        }
      })
      if (frontendConfig.length&&frontendConfig[0].value) {
        next('/' + frontendConfig[0].value || 'learning')
      }

    },400)
  }else if(token && to.path == '/'){
    setTimeout(()=>{
      let path = '/learning'
      let  frontendConfig = store.state.dynamic.frontendConfig.filter(item => {
        if (item.key === 'homepage') {
          return true;
        }
      })
      if (frontendConfig[0].key == 'homepage') {
        if (frontendConfig.length&&frontendConfig[0].value) {
          console.log(frontendConfig[0].value,'frontendConfig[0].valuevaluevalue++++')
          path = '/'+frontendConfig[0].value
        }
      }
      next({
        path: path
      })
    },400)
  }else if(!token && to.path == '/'){
    console.log(store.state.dynamic.frontendConfig,'+++')
    setTimeout(()=>{
      let path = '/login'
      const  frontendConfig = store.state.dynamic.frontendConfig.filter(item => {
        if (item.key === 'homepage') {
          return true;
        }
      })
      if (frontendConfig[0].key == 'homepage') {
        if (frontendConfig.length&&frontendConfig[0].value) {
          path = '/'+frontendConfig[0].value
        }
      }
      next({
        path: path
      })
    },400)
  }
  else if(!token && to.meta.login){ //
    next({
      path:'/login',
      query:{
        name: to.name
      }
    })
  }else {
    next()
  }

















  // const token = localStorage.getItem('token') || '';
  // if ((!token && to.meta.login)) {
  //   next({
  //     path: `/login`,
  //   });
  // } else {
  //
  //
  //   next()
  // }
  //

});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
